import { API_BASE_URL, API_REFRESH_PATH } from '../../consts';
import axios from 'axios';

// not acync
const refreshAccessToken = () => {
    const refresh = localStorage.getItem('refresh_token');

    // Create the POST request
    return axios.post(
        `${API_BASE_URL}${API_REFRESH_PATH}`,
        { refresh: refresh }, // The data should be an object
        {
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }
    ).then(response => {
        if (response.status === 200) {
            localStorage.clear();
            localStorage.setItem('access_token', response.data.access);
            localStorage.setItem('refresh_token', response.data.refresh);
            axios.defaults.headers.common['Authorization'] =
                `Bearer ${response.data['access']}`;
            // Return a resolved promise
            return response.data.access;
        }
        return Promise.resolve(response.data.access);
    }).catch(error => {
        if (error.response && error.response.status === 401) {
            // setClientMessage("Sorry but could not login with provided credentials");
            console.log(error.response.data);
        } else if (error.response && error.response.status === 500) {
            // setClientMessage("Please try later as we are experiencing an server error. Appologies for the inconvenience.");
            console.log('500', error.response.data);
        } else {
            // setClientMessage("Please try later as we are experiencing an error. Appologies for the inconvenience.");
            console.error('Error during sign up:', error);
        }
        // Return a rejected promise
        return Promise.reject(error);
    });
};

// acync ver
// const refreshAccessToken = async () => {
//     try {
//         const refresh = localStorage.getItem('refresh_token')
//         // Create the POST requuest
//         const response = await axios.post(
//             `${API_BASE_URL}${API_REFRESH_PATH}`,
//             { refresh: refresh }, // The data should be an object
//             {
//                 headers: { 'Content-Type': 'application/json' },
//                 withCredentials: true
//             }
//         );

//         //Initialize the access & refresh token in localstorage.

//         if (response.status === 200) {
//             localStorage.clear();
//             localStorage.setItem('access_token', response.data.access);
//             localStorage.setItem('refresh_token', response.data.refresh);
//             axios.defaults.headers.common['Authorization'] =
//                 `Bearer ${response.data['access']}`;
//             // return Promise.resolve();
//         }
//     } catch (error: any) {
//         if (error.response.status === 401) {
//             // setClientMessage("Sorry but could not login with provided credentials");
//             console.log(error.response.data);
//         } else if (error.response.status === 500) {
//             // setClientMessage("Please try later as we are experiencing an server error. Appologies for the inconvenience.");
//             console.log('500', error.response.data);
//         } else {
//             // setClientMessage("Please try later as we are experiencing an error. Appologies for the inconvenience.");
//             console.error('Error during sign up:', error);
//         }
//         // return Promise.reject(error);
//     }
// };


export default refreshAccessToken;
